import TelegramPost from "../telegram/TelegramPost";
import {useEffect} from "react";
import { hideIntercom } from "@qoohoo/common/utils/intercom";

export default function TelegramChannelView({ channelDetails, isWhiteTheme, customConfig }) {
  useEffect(()=>{
    if(customConfig?.removeSupportChatButton) {
      hideIntercom();
    }
  }, [])

  return (
    <>
      <TelegramPost
        channelDetails={channelDetails}
        isWhiteTheme={isWhiteTheme}
        customConfig={customConfig}
      />
    </>
  );
}
